import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';

import {ExpertFilterModel} from '../../../clause/expert-filter.model';
import {ClauseModel} from '../../../clause/clause.model';
import 'rxjs/add/observable/of';

@Injectable()
export class ClauseService extends BaseHttpService {

  private static clausesPath = 'api/ecv/clauses/';
  private static allExpertsNeedingProcessPath = ClauseService.clausesPath + 'users_needing_process';
  private static allClausesPath = ClauseService.clausesPath + 'all/';
  private static allClauseDescriptionsPath = ClauseService.clausesPath + 'all_clauses/';
  private static updateClausePath = ClauseService.clausesPath + 'update';
  private static createClausePath = ClauseService.clausesPath + 'create';
  private static deleteClausePath = ClauseService.clausesPath + 'delete/';


  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getAllExpertsNeedingProcess(model: ExpertFilterModel, pageNumber: number, pageSize: number, sort: string): Observable<any> {
    const queryString = model.toQueryString();
    const url = `${ClauseService.allExpertsNeedingProcessPath}${queryString}page=${pageNumber}&size=${pageSize}&sort=${sort}`;
    return this.httpGet(url);
  }

  getAllClauseDescriptions(clauseType: number): Observable<any> {
    return this.httpGet(ClauseService.allClauseDescriptionsPath + clauseType);
  }

  getAllClauses(userId: string): Observable<any> {
    return this.httpGet(ClauseService.allClausesPath + userId);
  }

  createClause(model: ClauseModel): Observable<any> {
    return this.httpPost(ClauseService.createClausePath, model).map(
      response => {
        Object.assign(model, response);
      })
      .catch((err) => Observable.of(true));
  }

  updateClause(model: ClauseModel): Observable<any> {
    return this.httpPut(ClauseService.updateClausePath, model).map(
      response => {
        Object.assign(model, response);
      })
      .catch((err) => Observable.of(true));
  }

  deleteClause(model: ClauseModel): Observable<any> {
    return this.httpDelete(ClauseService.deleteClausePath + model.id + '/' + model.version).map(() => {
        model.id = null;
      })
      .catch((err) => Observable.of(true));
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/clause.service.ts